<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10.3671 17.0294C16.763 13.4445 18.3365 9.1771 17.1334 6.17721C16.5493 4.72065 15.3233 3.67687 13.8772 3.35445C12.8284 3.12059 11.6993 3.27356 10.6561 3.87286C10.253 4.10445 9.74758 4.10445 9.34448 3.87286C8.30131 3.27356 7.17228 3.12059 6.12343 3.35445C4.67739 3.67688 3.45134 4.72067 2.86719 6.17721C1.66408 9.17718 3.23771 13.4445 9.63363 17.0294C9.86148 17.1571 10.1393 17.1571 10.3671 17.0294Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M9.9999 8V10M9.9999 10V12M9.9999 10H7.99988M9.9999 10H11.9999" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'HealthIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>